import axios from "axios";
import { HOST_API_KEY } from "../../config";
import { axiosInstanceWithToken } from "../utils/axios";

export const getAllFollowingData = async (userId) => {
  const response = await axios.get(
    `${HOST_API_KEY}/follower/get-all-following/${userId}`
  );
  return response?.data;
};

export const createFollowerData = async (data) => {
  const response = await axiosInstanceWithToken.post(`${HOST_API_KEY}/follower/`, data);
  return response?.data;
};

export const deleteFollowerData = async (id) => {
  const response = await axiosInstanceWithToken.delete(`${HOST_API_KEY}/follower/${id}`);
  return response?.data;
};

export const unfollowUser = async (data) => {
  const response = await axiosInstanceWithToken.delete(
    `${HOST_API_KEY}/follower/unfollow/${data?.followerId}/${data?.followingId}`
  );
  return response?.data;
};

export const createFriendRequest = async (data) => {
  const response = await axiosInstanceWithToken.post(`${HOST_API_KEY}/friend-request`, data);
  return response?.data;
}

export const getAllFriendRequests = async (id) => {
  const response = await axiosInstanceWithToken.get(`${HOST_API_KEY}/friend-request/${id}`);
  return response?.data;
}

export const acceptFriendRequest = async (reqId) => {
  const response = await axiosInstanceWithToken.post(`${HOST_API_KEY}/friend-request/${reqId}/accept`);
  return response?.data;
}

export const declineFriendRequest = async (reqId) => {
  const response = await axiosInstanceWithToken.patch(`${HOST_API_KEY}/friend-request/${reqId}/decline`);
  return response?.data;
}